module.exports = {"TXTWCL_Show_More":{"id":"TXTWCL_Show_More","defaultMessage":"Show More"}}